const hasValue = (...itens) => {
  itens = itens.map((item) => {
    return (item !== undefined) && (item !== '') && (item !== null)
  })

  return !itens.includes(false)
}

const getCnpjsParams = (cnpjs, key) => {
  if (typeof cnpjs === 'string') {
    return `${key}[]=${cnpjs.split(',').join(`&${key}[]=`)}`
  } else {
    if (cnpjs.length === 0) {
      return `${key}[]=`
    } else {
      return `${key}[]=${cnpjs.join(`&${key}[]=`)}`
    }
  }
}

const SET_DASHBOARD_SUMMARY = (state, list) => {
  state.dashboardSummary = list
}

const SET_DASHBOARD = (state, list) => {
  state.dashboard = list
}

const SET_CORRETOR = (state, list) => {
  state.corretor = list
}

const SET_SUMMARY_DATATABLE = (state, obj) => {
  Object.assign(state.summaryDatatable, obj)
}

const SET_PARAMS_QUERY_SUMMARY_DATATABLE = (state) => {
  // CNPJ
  let params = getCnpjsParams(state.summaryDatatable.cnpjs, 'assignor')

  // params cnpj_payer
  params += `&${getCnpjsParams(state.summaryDatatable.cnpjs_payers, 'payer')}`

  // Programada
  if (hasValue(state.summaryDatatable.scheduled_date_init, state.summaryDatatable.scheduled_date_end)) {
    params += `&scheduled_date_init=${state.summaryDatatable.scheduled_date_init}&scheduled_date_end=${state.summaryDatatable.scheduled_date_end}`
  }
  // Pagamento
  if (hasValue(state.summaryDatatable.payment_date_init, state.summaryDatatable.payment_date_end)) {
    params += `&payment_date_init=${state.summaryDatatable.payment_date_init}&payment_date_end=${state.summaryDatatable.payment_date_end}`
  }
  // Status
  if (hasValue(state.summaryDatatable.status)) {
    params += `&status=${state.summaryDatatable.status}`
  }
  // Numero Titulo
  if (hasValue(state.summaryDatatable.invoice_number)) {
    params += `&invoice_number=${state.summaryDatatable.invoice_number}`
  }
  state.summaryDatatable.paramsQuery = params
}

export default {
  SET_SUMMARY_DATATABLE,
  SET_PARAMS_QUERY_SUMMARY_DATATABLE,
  SET_DASHBOARD_SUMMARY,
  SET_DASHBOARD,
  SET_CORRETOR
}



// WEBPACK FOOTER //
// ./src/features/dashboard/store/mutations.js